import { useEffect, useState } from 'react';

interface ServerMetadata {
  clientIp: string;
  asOrganization: string;
  colo: string;
}

export function ServerInfo() {
  const [meta, setMeta] = useState<ServerMetadata>({
    clientIp: '—',
    asOrganization: '—',
    colo: '—',
  });

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch('https://speed.cloudflare.com/meta', { cache: 'no-store' });
        const d = await r.json();
        setMeta({
          clientIp: String(d.clientIp || '—').slice(0, 30),
          asOrganization: String(d.asOrganization || '—').slice(0, 22),
          colo: String(d.colo || '—').slice(0, 20),
        });
      } catch (error) {
        console.error('Failed to fetch server metadata:', error);
      }
    })();
  }, []);

  const Item = ({ label, value }: { label: string; value: string }) => (
    <div className="flex gap-2 items-center">
      <span className="text-[10px] text-[hsl(var(--st-dim))] uppercase tracking-widest">
        {label}
      </span>
      <span className="text-[hsl(var(--st-cyan))] text-xs truncate">{value}</span>
    </div>
  );

  return (
    <div className="bg-[hsl(var(--st-surface-1))] border border-[hsl(var(--st-border))] rounded-lg p-3 grid grid-cols-2 gap-3 gap-x-4 text-sm">
      <Item label="IP" value={meta.clientIp} />
      <Item label="ISP" value={meta.asOrganization} />
      <Item label="DC" value={meta.colo} />
      <Item label="SERVER" value="Cloudflare Edge" />
    </div>
  );
}